<div class="p-6 space-y-6">

  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Auditoría de Inscripciones</h1>
      <p class="mt-1 text-sm text-gray-500">
        Inscripciones con cobro automático activo. Verifica y ajusta el estado por fila o en lote.
      </p>
    </div>
  </div>

  <!-- Tabs -->
  <div class="border-b border-gray-200">
    <nav class="-mb-px flex space-x-6">
      <button
        (click)="setTab('individual')"
        [class]="activeTab === 'individual'
          ? 'border-b-2 border-blue-600 text-blue-600 font-semibold pb-3 text-sm'
          : 'text-gray-500 hover:text-gray-700 pb-3 text-sm border-b-2 border-transparent'">
        Individuales
        <span *ngIf="activeTab === 'individual' && individualTotal > 0"
          class="ml-1.5 bg-blue-100 text-blue-700 text-xs font-medium px-2 py-0.5 rounded-full">
          {{ individualTotal }}
        </span>
      </button>
      <button
        (click)="setTab('corporate')"
        [class]="activeTab === 'corporate'
          ? 'border-b-2 border-blue-600 text-blue-600 font-semibold pb-3 text-sm'
          : 'text-gray-500 hover:text-gray-700 pb-3 text-sm border-b-2 border-transparent'">
        Empresariales
        <span *ngIf="activeTab === 'corporate' && corporateTotal > 0"
          class="ml-1.5 bg-blue-100 text-blue-700 text-xs font-medium px-2 py-0.5 rounded-full">
          {{ corporateTotal }}
        </span>
      </button>
    </nav>
  </div>

  <!-- Filters -->
  <div class="flex flex-wrap gap-3 items-end">
    <div>
      <label class="block text-xs font-medium text-gray-600 mb-1">Estado</label>
      <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
        class="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option *ngFor="let opt of statusOptions" [ngValue]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 mb-1">Cobro automático</label>
      <select [(ngModel)]="filterAutoGenerate" (ngModelChange)="onFilterChange()"
        class="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option *ngFor="let opt of autoGenerateOptions" [ngValue]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 mb-1">Buscar</label>
      <input [(ngModel)]="filterSearch" (ngModelChange)="onFilterChange()"
        placeholder="Nombre, empresa, proyecto..."
        class="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-64" />
    </div>

    <!-- Bulk fix -->
    <div class="ml-auto flex items-end gap-2">
      <span *ngIf="selectedCount > 0" class="text-xs text-gray-600 self-center">
        {{ selectedCount }} seleccionado(s)
      </span>
      <button
        (click)="openBulkModal()"
        class="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
        </svg>
        Aplicar acción en lote
      </button>
    </div>
  </div>

  <!-- ========== INDIVIDUAL TAB ========== -->
  <div *ngIf="activeTab === 'individual'">
    <div *ngIf="individualLoading" class="flex justify-center py-12">
      <svg class="animate-spin h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
      </svg>
    </div>

    <div *ngIf="!individualLoading">
      <div *ngIf="individualItems.length === 0" class="text-center py-12 text-gray-500">
        No se encontraron inscripciones individuales con los filtros aplicados.
      </div>

      <div *ngIf="individualItems.length > 0" class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
        <table class="min-w-full divide-y divide-gray-100 text-sm">
          <thead class="bg-gray-50 text-xs text-gray-600 uppercase tracking-wide">
            <tr>
              <th class="px-4 py-3 text-left w-10">
                <input type="checkbox" [checked]="allIndividualSelected" (change)="selectAllIndividual()"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              </th>
              <th class="px-4 py-3 text-left">ID</th>
              <th class="px-4 py-3 text-left">Participante</th>
              <th class="px-4 py-3 text-left">Documento</th>
              <th class="px-4 py-3 text-left">Proyecto</th>
              <th class="px-4 py-3 text-left">Estado</th>
              <th class="px-4 py-3 text-center">Cobro automático</th>
              <th class="px-4 py-3 text-left">Creado</th>
              <th class="px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr *ngFor="let item of individualItems; trackBy: trackById"
              [class.bg-blue-50]="selectedIndividualIds.has(item.id)"
              class="hover:bg-gray-50 transition-colors">
              <td class="px-4 py-3">
                <input type="checkbox" [checked]="selectedIndividualIds.has(item.id)"
                  (change)="toggleSelectIndividual(item.id)"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              </td>
              <td class="px-4 py-3 font-mono text-gray-500">{{ item.id }}</td>
              <td class="px-4 py-3 font-medium text-gray-900">{{ item.participantName }}</td>
              <td class="px-4 py-3 text-gray-600 whitespace-nowrap">
                <span *ngIf="item.participantDocumentType" class="text-xs uppercase text-gray-500 mr-1">{{ item.participantDocumentType }}</span>
                <span class="font-mono">{{ item.participantDocumentId || '—' }}</span>
              </td>
              <td class="px-4 py-3 text-gray-600">
                <span *ngIf="item.projectMnemonic" class="inline-block px-1.5 py-0.5 mr-1.5 rounded bg-gray-100 text-gray-700 text-xs font-mono">{{ item.projectMnemonic }}</span>
                {{ item.projectName }}
              </td>
              <td class="px-4 py-3">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border"
                  [ngClass]="statusClass(item.status)">
                  {{ statusLabel(item.status) }}
                </span>
              </td>
              <td class="px-4 py-3 text-center">
                <button (click)="toggleIndividual(item)" type="button"
                  class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                  [class.bg-blue-600]="item.autoGeneratePaymentLinks"
                  [class.bg-gray-300]="!item.autoGeneratePaymentLinks">
                  <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform"
                    [class.translate-x-4]="item.autoGeneratePaymentLinks"
                    [class.translate-x-1]="!item.autoGeneratePaymentLinks">
                  </span>
                </button>
              </td>
              <td class="px-4 py-3 text-gray-500 whitespace-nowrap">
                {{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy') : '—' }}
              </td>
              <td class="px-4 py-3 text-center">
                <button (click)="goToIndividual(item.id)" type="button"
                  title="Ver detalle"
                  class="text-blue-600 hover:text-blue-800 transition-colors">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- ========== CORPORATE TAB ========== -->
  <div *ngIf="activeTab === 'corporate'">
    <div *ngIf="corporateLoading" class="flex justify-center py-12">
      <svg class="animate-spin h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
      </svg>
    </div>

    <div *ngIf="!corporateLoading">
      <div *ngIf="corporateItems.length === 0" class="text-center py-12 text-gray-500">
        No se encontraron inscripciones empresariales con los filtros aplicados.
      </div>

      <div *ngIf="corporateItems.length > 0" class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
        <table class="min-w-full divide-y divide-gray-100 text-sm">
          <thead class="bg-gray-50 text-xs text-gray-600 uppercase tracking-wide">
            <tr>
              <th class="px-4 py-3 text-left w-10">
                <input type="checkbox" [checked]="allCorporateSelected" (change)="selectAllCorporate()"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              </th>
              <th class="px-4 py-3 text-left">ID</th>
              <th class="px-4 py-3 text-left">Empresa</th>
              <th class="px-4 py-3 text-left">Documento</th>
              <th class="px-4 py-3 text-left">Proyecto</th>
              <th class="px-4 py-3 text-left">Estado</th>
              <th class="px-4 py-3 text-center">Participantes</th>
              <th class="px-4 py-3 text-center">Cobro automático</th>
              <th class="px-4 py-3 text-left">Creado</th>
              <th class="px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr *ngFor="let item of corporateItems; trackBy: trackById"
              [class.bg-blue-50]="selectedCorporateIds.has(item.id)"
              class="hover:bg-gray-50 transition-colors">
              <td class="px-4 py-3">
                <input type="checkbox" [checked]="selectedCorporateIds.has(item.id)"
                  (change)="toggleSelectCorporate(item.id)"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              </td>
              <td class="px-4 py-3 font-mono text-gray-500">{{ item.id }}</td>
              <td class="px-4 py-3 font-medium text-gray-900">{{ item.companyName }}</td>
              <td class="px-4 py-3 text-gray-600 whitespace-nowrap">
                <span *ngIf="item.companyDocumentType" class="text-xs uppercase text-gray-500 mr-1">{{ item.companyDocumentType }}</span>
                <span class="font-mono">{{ item.companyDocumentId || '—' }}</span>
              </td>
              <td class="px-4 py-3 text-gray-600">
                <span *ngIf="item.projectMnemonic" class="inline-block px-1.5 py-0.5 mr-1.5 rounded bg-gray-100 text-gray-700 text-xs font-mono">{{ item.projectMnemonic }}</span>
                {{ item.projectName }}
              </td>
              <td class="px-4 py-3">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border"
                  [ngClass]="statusClass(item.status)">
                  {{ statusLabel(item.status) }}
                </span>
              </td>
              <td class="px-4 py-3 text-center text-gray-600">{{ item.participantCount }}</td>
              <td class="px-4 py-3 text-center">
                <button (click)="toggleCorporate(item)" type="button"
                  class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                  [class.bg-blue-600]="item.autoGeneratePaymentLinks"
                  [class.bg-gray-300]="!item.autoGeneratePaymentLinks">
                  <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform"
                    [class.translate-x-4]="item.autoGeneratePaymentLinks"
                    [class.translate-x-1]="!item.autoGeneratePaymentLinks">
                  </span>
                </button>
              </td>
              <td class="px-4 py-3 text-gray-500 whitespace-nowrap">
                {{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy') : '—' }}
              </td>
              <td class="px-4 py-3 text-center">
                <button (click)="goToCorporate(item.id)" type="button"
                  title="Ver detalle"
                  class="text-blue-600 hover:text-blue-800 transition-colors">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div *ngIf="totalPages > 1" class="flex items-center justify-between pt-2">
    <p class="text-sm text-gray-500">
      Página {{ pageNumber }} de {{ totalPages }}
    </p>
    <div class="flex items-center gap-1">
      <button (click)="goToPage(pageNumber - 1)" [disabled]="pageNumber === 1"
        class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
        ‹
      </button>
      <button *ngFor="let p of pageNumbers"
        (click)="goToPage(p)"
        [class]="p === pageNumber
          ? 'px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg font-medium'
          : 'px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors'">
        {{ p }}
      </button>
      <button (click)="goToPage(pageNumber + 1)" [disabled]="pageNumber === totalPages"
        class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
        ›
      </button>
    </div>
  </div>

  <!-- ========== BULK FIX MODAL ========== -->
  <div *ngIf="showBulkModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    (click)="closeBulkModal()">
    <div class="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
      (click)="$event.stopPropagation()">
      <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <h2 class="text-lg font-semibold text-gray-900">Bulk fix —
          <span class="text-blue-600">{{ activeTab === 'individual' ? 'Individuales' : 'Empresariales' }}</span>
        </h2>
        <button (click)="closeBulkModal()" class="text-gray-400 hover:text-gray-600">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="px-6 py-4 space-y-4">
        <!-- Scope -->
        <div>
          <label class="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">¿A qué aplicar?</label>
          <div class="space-y-2">
            <label class="flex items-center gap-2 cursor-pointer p-3 border border-gray-200 rounded-lg hover:bg-gray-50"
              [class.border-blue-500]="bulkScope === 'selected'"
              [class.bg-blue-50]="bulkScope === 'selected'">
              <input type="radio" name="bulkScope" [value]="'selected'"
                [(ngModel)]="bulkScope" (ngModelChange)="onBulkScopeChange()"
                [disabled]="selectedCount === 0"
                class="text-blue-600 focus:ring-blue-500" />
              <span class="text-sm">
                Solo seleccionados
                <span class="font-semibold ml-1">({{ selectedCount }})</span>
              </span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer p-3 border border-gray-200 rounded-lg hover:bg-gray-50"
              [class.border-blue-500]="bulkScope === 'filtered'"
              [class.bg-blue-50]="bulkScope === 'filtered'">
              <input type="radio" name="bulkScope" [value]="'filtered'"
                [(ngModel)]="bulkScope" (ngModelChange)="onBulkScopeChange()"
                class="text-blue-600 focus:ring-blue-500" />
              <span class="text-sm">
                Todos los filtrados
                <span class="font-semibold ml-1">({{ filteredTotal }})</span>
              </span>
            </label>
          </div>
        </div>

        <!-- Action -->
        <div>
          <label class="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Acción</label>
          <select [(ngModel)]="bulkAction" (ngModelChange)="onBulkActionChange()"
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="SetAutoGenerate">Cobro automático (activar / desactivar)</option>
            <option value="SetStatus">Cambiar estado de la inscripción</option>
          </select>
        </div>

        <!-- Value -->
        <div *ngIf="bulkAction === 'SetAutoGenerate'">
          <label class="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Valor</label>
          <div class="flex gap-2">
            <button type="button" (click)="bulkValueBool = true; bulkPreview = null"
              [class]="bulkValueBool
                ? 'flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium'
                : 'flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200'">
              Activar
            </button>
            <button type="button" (click)="bulkValueBool = false; bulkPreview = null"
              [class]="!bulkValueBool
                ? 'flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium'
                : 'flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200'">
              Desactivar
            </button>
          </div>
        </div>

        <div *ngIf="bulkAction === 'SetStatus'">
          <label class="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Nuevo estado</label>
          <select [(ngModel)]="bulkValueStatus" (ngModelChange)="bulkPreview = null"
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option [ngValue]="null">— Selecciona estado —</option>
            <option *ngFor="let s of statusValueOptions" [ngValue]="s.value">{{ s.label }}</option>
          </select>
          <p class="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded p-2 mt-2">
            ⚠️ Cambiar el estado puede tener efectos sobre las cuotas y cobros. Verifica antes de confirmar.
          </p>
        </div>

        <!-- Comment -->
        <div>
          <label class="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Motivo (mín. 10 caracteres)</label>
          <textarea [(ngModel)]="bulkComment" rows="3"
            placeholder="Describe el motivo de esta operación masiva..."
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
          <div class="text-xs mt-1" [class.text-gray-500]="bulkComment.trim().length >= 10"
            [class.text-red-600]="bulkComment.trim().length > 0 && bulkComment.trim().length < 10">
            {{ bulkComment.trim().length }} / 10
          </div>
        </div>

        <!-- Preview result -->
        <div *ngIf="bulkPreview" class="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <p class="text-sm font-semibold text-gray-900 mb-2">
            Vista previa: {{ bulkPreview.totalOperations }} inscripción(es) afectadas.
          </p>
          <div *ngIf="bulkPreview.sampleTargets.length > 0" class="max-h-40 overflow-y-auto">
            <table class="w-full text-xs">
              <thead class="text-gray-500 uppercase">
                <tr>
                  <th class="text-left py-1">ID</th>
                  <th class="text-left py-1">Nombre</th>
                  <th class="text-left py-1">Estado actual</th>
                  <th class="text-center py-1">Auto-gen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of bulkPreview.sampleTargets" class="border-t border-gray-200">
                  <td class="py-1 font-mono text-gray-500">{{ t.id }}</td>
                  <td class="py-1 text-gray-700">{{ t.display }}</td>
                  <td class="py-1 text-gray-600">{{ statusLabel(t.currentStatus) }}</td>
                  <td class="py-1 text-center">{{ t.currentAutoGenerate ? '✓' : '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p *ngIf="bulkPreview.totalOperations > bulkPreview.sampleTargets.length" class="text-xs text-gray-500 mt-2">
            Mostrando {{ bulkPreview.sampleTargets.length }} de {{ bulkPreview.totalOperations }}.
          </p>
        </div>
      </div>

      <div class="px-6 py-4 border-t border-gray-200">
        <p *ngIf="bulkBlockReason" class="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded p-2 mb-3">
          ⚠️ {{ bulkBlockReason }}
        </p>
        <div class="flex items-center justify-between gap-2">
          <button (click)="closeBulkModal()" type="button"
            class="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50">
            Cancelar
          </button>
          <div class="flex gap-2">
            <button (click)="loadBulkPreview()" type="button" [disabled]="bulkPreviewLoading || !canPreview"
              class="px-4 py-2 text-sm font-medium text-blue-700 border border-blue-300 rounded-lg hover:bg-blue-50 disabled:opacity-50">
              {{ bulkPreviewLoading ? 'Calculando...' : (bulkPreview ? 'Recargar vista previa' : 'Vista previa') }}
            </button>
            <button (click)="confirmBulk()" type="button" [disabled]="!canConfirmBulk"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50">
              {{ bulkStarting ? 'Iniciando...' : 'Confirmar e iniciar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
